import {
    TopToolbar,
    ExportButton,
    CreateButton,
    Pagination,
    useGetIdentity,
    ListBase,
    Title,
    ListToolbar,
    useListContext,
    SortButton,
} from 'react-admin';

import { ImageList } from './GridList';
import { FundListFilter } from './FundListFilter';
import { Stack } from '@mui/material';

export const FundList = () => {
    const { identity } = useGetIdentity();
    if (!identity) return null;
    return (
        <ListBase perPage={10} sort={{ field: 'name', order: 'ASC' }}>
            <FundListLayout />
        </ListBase>
    );
};

const FundListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (isPending) return null;

    return (
        <Stack direction="row" component="div">
            <FundListFilter />
            <Stack sx={{ width: '100%' }}>
                <Title title={'Funds'} />
                <ListToolbar actions={<FundListActions />} />
                <ImageList />
                <Pagination rowsPerPageOptions={[10, 25]} />
            </Stack>
        </Stack>
    );
};

const FundListActions = () => {
    return (
        <TopToolbar>
            <SortButton fields={['name', 'created_at', 'nb_contacts']} />
        </TopToolbar>
    );
};
